<template>
  <div class="mb-6">
    <div class="flex flex-col gap-4">
      <SmallCheckbox
        :checked="acknowledged"
        :name="`consent-${consent.checkboxId}`"
        :label="getCheckboxLabel(consent)"
        :data-test="`consent-checkbox-${consent.checkboxId}`"
        class="check-box"
        @click="handleToggle" />

      <div
        v-if="hasRichContent(consent.label)"
        class="ml-6 paragraph-2 text-blue-1 cursor-pointer"
        v-html="consent.label" />
    </div>

    <!-- Consent Content (bullet points) -->
    <div
      v-if="Array.isArray(consent.content) && consent.content.length > 0"
      class="my-6 p-4 rounded-lg bg-blue-50">
      <div class="mb-4">
        <ul class="gap-y-2 ml-5">
          <li
            v-for="(item, index) in consent.content"
            :key="index"
            class="paragraph-2 flex items-start">
            <span class="mr-2">•</span>
            <span>{{ item }}</span>
          </li>
        </ul>
      </div>
    </div>
    <!-- Single content paragraph -->
    <div
      v-else-if="typeof consent.content === 'string' && consent.content"
      class="mb-6 p-4 rounded-lg bg-blue-50">
      <div class="paragraph-1">
        {{ consent.content }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import SmallCheckbox from '@/components/BasicInputs/CustomCheckBox/SmallCheckbox.vue'
import type { ConsentSection } from '@/types/SuperfundDisclaimerTypes'

interface Props {
  consent: ConsentSection
  acknowledged: boolean
}

interface Emits {
  (e: 'toggle'): void
}

defineProps<Props>()
const emit = defineEmits<Emits>()

const handleToggle = () => {
  emit('toggle')
}

const hasRichContent = (label: string): boolean => {
  return label.includes('<') || label.includes('>')
}

const getCheckboxLabel = (consent: ConsentSection): string => {
  // If it has HTML/markup, just show a simple label for the checkbox
  if (hasRichContent(consent.label)) {
    return `I agree to the terms described below`
  }
  // Otherwise use the full label
  return consent.label
}
</script>
